import { render } from "./ItemSearch.vue?vue&type=template&id=458bb5a3"
import script from "./ItemSearch.vue?vue&type=script&lang=ts"
export * from "./ItemSearch.vue?vue&type=script&lang=ts"
script.render = render

export default script